import { isDefined } from "@clipboard-health/util-ts";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { environmentConfig } from "@src/appV2/environment";
import {
  type FacilityExclusionApiResponse,
  getFacilityExclusionResponseSchema,
} from "@src/appV2/Facilities/api/useGetFacilitiesExclusions";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";

interface UseGetFacilityExclusionParams {
  facilityId: string;
  agentId: string;
}

export function useGetFacilityExclusion(
  params: UseGetFacilityExclusionParams,
  options: UseGetQueryOptions<FacilityExclusionApiResponse> = {}
) {
  const { facilityId, agentId } = params;

  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/exclusion`,
    queryParams: { facilityId, agentId },
    responseSchema: getFacilityExclusionResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_EXCLUSION_FAILURE,
    },
    enabled: isDefined(facilityId) && isDefined(agentId),
    ...options,
  });
}
